import useInvoiceListPage from './useInvoiceListPage';

function InvoiceListPage(): JSX.Element {
  const { Component } = useInvoiceListPage();

  return <Component />;
}

export default InvoiceListPage;
